<template>
  <div class="box4">
    <pageTitle title="课程体系全新升级&nbsp;&nbsp;贴合企业刚需技术点" />
    
    <div class="bottom">
       <img src="../../../assets/coursePage/linux/box4/img01.png"/>
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box4 {
background: linear-gradient( 270deg, #F3F7FF 0%, #F9FBFF 100%); 
  padding: 60px 0 40px;

  .bottom{
    display: flex;
    overflow-x: auto;
    width: 100%;
    margin-top: 48px;
    img{
      width: 1200px;
      margin: 0 0 40px 30px;
    }
    img:last-child{margin-right: 30px;}
  }
}
</style>
